import React, { useEffect } from "react";
import { useGlobalState } from "../../GlobalStates";

const TempLine = () => {
  const [user, setUser] = useGlobalState("user");

  useEffect(() => {
    localStorage.removeItem("USER_ID");
    localStorage.removeItem("JWT_TOKEN");
    localStorage.removeItem("locale");
    localStorage.removeItem("currency");
    localStorage.removeItem("community");
    window.location.href = "/";
    window.postMessage("logout");
    setUser({});
    window.location.href = "/login?reroute=/temp-account-merge";
  }, []);

  return null;
};

export default TempLine;
